import { action } from 'satcheljs';

/**
 * Hides the surface context menu
 * This action has a stitch. Update requestModuleCommand when changing action name
 */

let hideSurfaceContextMenu = action('hideSurfaceContextMenu');

export default hideSurfaceContextMenu;
